<template>
    <div class="not-found">
        <!-- <h1>页面未找到</h1> -->
        <p>问卷错误</p>
    </div>
</template>
  
<script>
export default {
    name: 'NotFound'
}
</script>
  
<style scoped>
.not-found {
    text-align: center;
    margin-top: 50px;
    font-size: 24px;
}
</style>
